<template>
  <iColumn
    :height="chatroomHeight"
    :min-height="getOptionValue(MinHeight)"
  >
    <div class="message-placeholder-container">
      <div class="small-message-placeholder" />
      <div class="medium-message-placeholder right" />
      <div class="small-message-placeholder" />
      <div class="large-message-placeholder right" />
      <div class="small-message-placeholder" />
    </div>
  </iColumn>
</template>

<script>
// `~/stores/channel-store` + `%/apps/conversations/components/ChatroomV2.vue`
// live outside the editor directory tree. Canvas preview renders the
// same placeholder bubbles the original showed in edit mode.
import {
  ChatRoomPageElementMixin,
} from "%/dynamic-component-editor/standard-pages/chat-room-page/chat-room-page-element-mixin";
import MinHeight from "%/dynamic-component-editor/options/min-height";

export default {
  name: "DynamicChatRoomThread",
  mixins: [ChatRoomPageElementMixin],
  data() {
    return {
      MinHeight,
    };
  },
  options: [
    new MinHeight({
      default: 300,
    }),
  ],
};
</script>

<style lang="scss" scoped>
.message-placeholder-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}
.small-message-placeholder,
.medium-message-placeholder,
.large-message-placeholder {
  height: 24px;
  border-radius: 12px;
  background: #e3e7ec;
}
.small-message-placeholder {
  width: 30%;
}
.medium-message-placeholder {
  width: 55%;
}
.large-message-placeholder {
  width: 75%;
}
.right {
  align-self: flex-end;
  background: #cdd6df;
}
</style>
